// extracted by mini-css-extract-plugin
export var copyableField = "_p2-4";
export var customerBadge = "_p2-0";
export var customerInfoTitle = "_p2-2";
export var details = "_p2-1";
export var dropdownContainer = "_p2-5";
export var dropdownImage = "_p2-6";
export var editAssigneeForm = "_p2-a";
export var editButton = "_p2-3";
export var email = "_p2-7";
export var hidden = "_p2-d";
export var input = "_p2-8";
export var saveButton = "_p2-b";
export var shopifyIcon = "_p2-c";
export var suggestionBadge = "_p2-e";
export var suggestionText = "_p2-f";
export var username = "_p2-9";